import './AssembledComponentSkuTile.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

interface AssembledComponentSkuTileProps extends b2x.AssembledComponentSkuTileProps {
  assembledComponent?: b2x.AssembledComponent;
}

export const AssembledComponentSkuTile = (props: AssembledComponentSkuTileProps) => (
  <b2x.AssembledComponentSkuTile {...props} customComponent={_AssembledComponentSkuTile} />
);

export const _AssembledComponentSkuTile = ({ assembledComponent, componentSku }: AssembledComponentSkuTileProps) => {
  const product = componentSku.sku?.product;
  const sku = componentSku.sku;

  if (product === undefined) {
    throw new Error(`Product undefined for componentSku: ${componentSku.code}`);
  }

  if (sku === undefined) {
    throw new Error(`Sku undefined for componentSku: ${componentSku.code}`);
  }

  product.skus = [sku];

  const onClick = React.useCallback(() => {
    assembledComponent?.componentSkus?.map(
      (_componentSku) => _componentSku.quantity === 1 && _componentSku.removeQuantity()
    );
    componentSku.addQuantity();
  }, [assembledComponent, componentSku]);

  const imageUrl = sku.attributes?.find((attribute) => attribute.typeCode === 'BSK_ICONA_COLORE')?.value;
  const label = sku.attributes?.find((attribute) => attribute.typeCode === 'BSK_NOME_VARIANTE')?.value ?? sku.name;

  const selected = componentSku.quantity > 0;

  return (
    <b2x.Div className={classnames('assembled-component-sku-tile', { selected: selected })}>
      {imageUrl ? (
        <b2x.Button onClick={onClick} variant="blank">
          <b2x.Div className="img-container">
            <b2x.Image alt={label} src={{ xs: imageUrl }} style={{ objectFit: 'cover' }} title={label} />
          </b2x.Div>
        </b2x.Button>
      ) : (
        <b2x.Button className="btn-sm d-none" onClick={onClick} variant={selected ? 'primary' : 'outline-primary'}>
          {label}
        </b2x.Button>
      )}
    </b2x.Div>
  );
};
